export default __webpack_public_path__ + "static/media/nserix-primary.284ce00a.svg";